<lib-modal-layout [title]="title()" [subtitle]="''">
  <div *ngIf="data.requestType !== 'Loss Runs'" >
  <div *ngIf="pendingRequestStore.submissionReview?.()?.payrollDefaultedByRenewal" class="flex items-center justify-center gap-2 mb-4 text-red font-semibold">
    <span>Renewal automation defaulted Owners, Employee Payroll and Work Percentages</span>
    <a class="w-4 cursor-pointer" title="Edit" (click)="editRenewalPayroll()">
      <lib-icon icon="pen"></lib-icon>
    </a>
  </div>
  <lib-action-form [submissionGuid]="data.id!" [requestType]="data.requestType!" [proposedEffectiveDate]="proposedEffectiveDate" [effectiveDate]="data.effectiveDate" (closeModal)="dialogRef.close()"></lib-action-form>
  <lib-submission-review [model]="pendingRequestStore.submissionReview?.()!"></lib-submission-review>
  </div>
  <div *ngIf="data.requestType === 'Loss Runs' && pendingRequestStore.lossRunReview?.()">
   <lib-loss-runs-form [model]="pendingRequestStore.lossRunReview?.()!" (closeModal)="dialogRef.close()"></lib-loss-runs-form>
   <lib-ui-loss-runs-review [model]="pendingRequestStore.lossRunReview?.()!"></lib-ui-loss-runs-review>
  </div>
</lib-modal-layout>